/** @type {Record<string, unknown>} */
export const coreEn = {
  grain: {
    fixed: "Grain direction fixed. Do not rotate panels 90°",
    free: "No grain direction. Panels may be rotated 90°",
    noRotation: "Do not rotate panels 90°",
  },
  strategy: {
    efficient_cutting: {
      label: "Efficient cutting",
      description: "Cut as practically as possible with as few unnecessary cuts as needed.",
    },
    preserve_offcuts: {
      label: "Preserve large offcuts",
      description: "Where possible, preserve and include large rectangular offcut pieces.",
    },
    strips: {
      label: "Deliver strips",
      description: "Cut full strips; you trim to final size at home. Best for repeated board widths.",
    },
  },
  strip: {
    whenToUse: {
      title: "When to deliver strips?",
      body: "When the cut shop may saw full strips (e.g. 2440 × 400 mm) and you trim to length at home. Works best when multiple parts share the same strip width and no cut crosses through other parts.",
      example: "Example: four boards of 800 × 400 mm from one 2440 × 400 mm strip.",
    },
    whenBlocked: {
      title: "Strips not possible on this sheet",
      body: "The strip cut would cross through another part on the same sheet. That is almost always the case with mixed layouts (desks, cabinets with different sizes).",
      fallback: "Use efficient cutting or preserve large offcuts. You can set larger order sizes per part manually in the cut list if you finish at home.",
    },
    noEligibleSheets: {
      title: "Strips do not fit this project",
      body: "No sheet has a simple strip layout. Choose efficient cutting as the default.",
    },
    emptySheet: {
      title: "Empty sheet",
      body: "This sheet has no parts.",
    },
    crossesPanel: {
      horizontal: "horizontal",
      vertical: "vertical",
      unknownPart: "a part",
      message: "A {{axis}} strip cut (around {{position}}) would cross through {{panelName}}. {{body}}",
    },
  },
  offcut: {
    fullSheet: "full sheet",
    loose: "loose offcut",
    rightPanel: "right offcut panel",
    bottomPanel: "bottom offcut panel",
    freeArea: "free offcut area",
  },
  boardLabel: {
    offcutDefault: "OFFCUT",
    offcutSelfTrim: "TRIM YOURSELF",
    stripBannerNoCrosscut: "DELIVER FULL STRIPS. DO NOT TRIM TO LENGTH",
    stripBannerCrosscut: "DELIVER STRIPS, THEN TRIM TO CUT SIZE",
    placementStripSelfTrim: "CUT SIZE: trim from strip yourself",
  },
  cutSummary: {
    singular: "{{count}} cut · {{mode}}",
    plural: "{{count}} cuts · {{mode}}",
    mode: {
      strips: "strips",
      preserve: "preserve offcuts",
      efficient: "efficient",
    },
  },
  preview: {
    noCutsTitle: "No cuts performed yet",
    noCutsDetail: "Step through the numbered cuts to review the order.",
    cutTitle: "Cut {{number}}: {{caption}}",
  },
  sheetInstruction: {
    exactPrefix: "The cut dimensions in the table are authoritative. ",
    efficient: "{{prefix}}Please cut efficiently with as few unnecessary cuts as possible. Where practical, make long continuous cuts first.",
    preserve: "{{prefix}}Please preserve and include large rectangular offcut pieces where possible.",
    preserveWithOffcut: "{{prefix}}Please preserve and include large rectangular offcut pieces where possible. Potentially usable offcut: approx. {{size}} ({{offcutLabel}}).",
    strips: "{{prefix}}Please cut logical strips first and do not trim them to length. Deliver strips as long as possible; I will trim to final size myself.",
    stripsWithOffcuts: "{{prefix}}Please cut logical strips first and do not trim them to length. Deliver strips as long as possible; I will trim to final size myself. Expected trim pieces per strip after self-trimming: {{offcutSizes}}.",
    empty: "",
  },
  rowInstruction: {
    stripDeliver: "Deliver as strip; do not trim to length. Length will be trimmed at home.",
    trimLength: "trim length later from {{from}} to {{to}}",
    trimWidth: "trim width later from {{from}} to {{to}}",
    joined: "{{parts}}",
    orderDiffers: "Order size differs from final size.",
    exactPreserve: "Cut exactly to the specified cut size. Preserve large offcut pieces where practical.",
    cutPreserve: "Cut to size. Preserve large offcut pieces where practical.",
    exact: "Cut exactly to the specified cut size.",
    cutPerSize: "Cut to size.",
    cutToSize: "Cut to order size.",
    shortStrip: "Deliver strip; do not trim",
    shortExact: "Cut exactly",
    shortOrderSize: "Deliver order size",
    shortCut: "Cut",
  },
  edge: {
    top: "top",
    right: "right",
    bottom: "bottom",
    left: "left",
    none: "none",
    single: "{{side}}",
    list: "{{sides}}",
  },
  csv: {
    quantity: "Quantity",
    orderLength: "Cut length (mm)",
    orderWidth: "Cut width (mm)",
    finalLength: "Final length (mm)",
    finalWidth: "Final width (mm)",
    thickness: "Thickness (mm)",
    description: "Description",
    project: "Project",
    material: "Material",
    edges: "Edges",
    sheet: "Sheet",
    instruction: "Instruction",
  },
  printSummary: {
    stripsDeliver: "Deliver as full strip: {{sizes}}.",
    stripsDefault: "Deliver as full strips; do not trim to length.",
    stripsTrimTo: "Trim to: {{sizes}}.",
    stripsSelfCut: "Expected self-trimmed: {{sizes}}.",
    preservePrimary: "If practical, include one primary offcut piece: approx. {{size}}.",
    preserveGeneric: "If practical, preserve and include larger offcut pieces.",
    efficient: "Cut efficiently according to the cut sizes in the cut list.",
  },
  unnamedPanel: "Unnamed panel",
  unnamedProject: "Unnamed project",
  restUnused: {
    defaultLabel: "Offcut {{length}} × {{width}}",
    invalid: "Enter a valid length, width (min. {{minSize}}) and quantity.",
    wrongThickness: "No parts of {{thickness}} in this plan.",
    tooSmall: "No part fits on {{length}} × {{width}}.",
    notNeeded: "Not used: other sheets are enough for this layout.",
  },
  errors: {
    invalidProjectFile: "Invalid project file.",
    unsupportedProjectVersion: "Unsupported project version: {{version}}.",
    missingProjectData: "Invalid project file: no project data found.",
    invalidHandover: "Invalid project handoff.",
    missingHandoverPayload: "No project data in the link.",
    unsupportedHandoverVersion: "Unsupported handoff version: {{version}}.",
    unsupportedHandoverCodec: "Unsupported handoff codec: {{codecId}}.",
    emptyHandoverPayload: "Invalid handoff: empty payload.",
    utf8EncoderUnavailable: "UTF-8 encoder unavailable.",
    utf8DecoderUnavailable: "UTF-8 decoder unavailable.",
    sheetNotFound: "Sheet not found.",
  },
  stripDelivery: {
    notApplicable: "n/a",
  },
};
